import React from "react";
import Navbar from "@/components/site/Navbar";
import HeroSlider from "@/components/site/HeroSlider";
import HeroIntro from "@/components/site/HeroIntro";
import Services from "@/components/site/Services";
import Categories from "@/components/site/Categories";
import About from "@/components/site/About";
import Portfolio from "@/components/site/Portfolio";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-[#1a1a1a] text-white">
      <Navbar />
      <HeroSlider />
      <HeroIntro />
      <Services />
      <Categories />
      <About />
      <Portfolio />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
